import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { jsonToURL, mmHost, msToHHMMSS } from "../../../../../utils";
import InputBar from "../../minda/InputBar/InputBar";

export function WeldLine() {

    const [loading, setloading] = useState(false);
    const [weldLineData, setWeldLineData] = useState({});
    const [fetchStatus, setFetchStatus] = useState(true);
    

    let plantId = useSelector((state) => state.saveSelectedPlant);
    if (plantId.weldLine) {
      plantId = plantId.weldLine.selectedOption.value;
    } else {
      plantId = "";
    }
  
    let lineId = useSelector((state) => state.saveSelectedLine);
    if (lineId.weldLine) {
      lineId = lineId.weldLine.selectedOption.value;
    } else {
      lineId = "";
    }

    let queryParams = {
      plantId,
      lineId
    };


    const updateData = async () => {
 
      let api = `${mmHost}/chartserver/weldAnalysis2?${jsonToURL(
        queryParams
      )}`;

  
      setloading(true);
      axios.get(api).then(function (data) {
          setWeldLineData(data.data.res.data.report_2);
          setloading(false);
          return;
        }).catch(() => {
          setloading(false);
          return;
        });
    };

    useEffect(() => {
      updateData();
    }, [fetchStatus]);
  
    useEffect(() => {
      setTimeout(() => {
        setFetchStatus(!fetchStatus);
      }, 500);
    }, []);

    useEffect(() => {
      setInterval(updateData,10000);
    }, []);    

   let {actualProduction,
    downtime,
    gap,
    oee,
    targetProduction} = weldLineData;
   console.log(weldLineData)


  return (
    <>
      <div className="box box-default">
        <div className="box-header">
          <InputBar
            setData={setWeldLineData}
            setFetchStatus={setFetchStatus}
            fetchStatus={fetchStatus}
            loading={loading}
            InsIden={"weldLine"}
            machineType={false}
            line={true}
            machine={false}
            shift={false}
            shiftDate={false}
          ></InputBar>
        </div>
        <div className="box-body">
          <Row>
            <Col>
              <Card className="text-center">
                <Card.Header><h3>Production Count</h3></Card.Header>
                <Card.Body>
                  {/* <Card.Title>Special title treatment</Card.Title> */}
                  <Card.Text>
                    <h5><span style={{color:'#A9A9A9'}}>Target</span>  {targetProduction}</h5>
                    <h5><span style={{color:'#A9A9A9'}}>Actual</span>  {actualProduction}</h5>
                  </Card.Text>
                  {/* <Button variant="primary">Go somewhere</Button> */}
                </Card.Body>
                {/* <Card.Footer className="text-muted">2 days ago</Card.Footer> */}
              </Card>
            </Col>

            <Col>
              <Card className="text-center">
                <Card.Header><h3>Downtime <span style={{color:'#A9A9A9'}}>hh:mm:ss</span></h3></Card.Header>
                <Card.Body>
                  {/* <Card.Title>Special title treatment</Card.Title> */}
                  <Card.Text>
                  <h5>{msToHHMMSS(downtime)}</h5>
                  </Card.Text>
                  {/* <Button variant="primary">Go somewhere</Button> */}
                </Card.Body>
                {/* <Card.Footer className="text-muted">2 days ago</Card.Footer> */}
              </Card>
            </Col>

            <Col>
              <Card className="text-center">
                <Card.Header><h3>OEE <span style={{color:'#A9A9A9'}}>{`(%)`}</span> </h3></Card.Header>
                <Card.Body>
                  {/* <Card.Title>Special title treatment</Card.Title> */}
                  <Card.Text>
                    <h5>{oee}</h5>
                  </Card.Text>
                  {/* <Button variant="primary">Go somewhere</Button> */}
                </Card.Body>
                {/* <Card.Footer className="text-muted">2 days ago</Card.Footer> */}
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
